import { render, staticRenderFns } from "./LineDetail.vue?vue&type=template&id=b4d963aa&"
import script from "./LineDetail.vue?vue&type=script&lang=ts&"
export * from "./LineDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports